module.exports = __webpack_public_path__ + "75b8cbda5760cba43925f646ec671b3d.pdf";